import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, } from '@angular/core';
import { DisplayMode, SelectBox } from 'cbc-shared-lib';
import { ControlContainer, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, FormGroupDirective, Validators, } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { CodeConversionMstDto, ExtractionconditionInfoDto, LocationgroupsupplypointExtractionconditionInformationDto, Sgkc026aResponse } from 'sg-api';
import { PreSelectBox } from '../../../../../sg-kc-shared/constants/preSelectBox';
import { SearchStat } from '../../../../../sg-kc-shared/constants/searchStat';
import { EnergyTypeCode } from '../../../../../sg-kc-shared/constants/energyTypeCode ';

/** 単価表検索画面 （検索条件）
 * @export
 * @class Sgkc021dTankaTableSearchConditionComponent
 * @implements { OnInit, OnDestroy, OnChanges }
 */
@Component({
    selector: 'app-sgkc021d-tanka-table-search-condition',
    templateUrl: './sgkc021d-tanka-table-search-condition.component.html',
    styleUrl: './sgkc021d-tanka-table-search-condition.component.scss',
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class Sgkc021dTankaTableSearchConditionComponent implements OnInit, OnDestroy, OnChanges {

    /** 各必須項目の初期値 */
    readonly DEFAULT_SELECT_VALUE = " ";

    /** 検索ボタン押下イベント */
    @Output() onClickSearchEvent = new EventEmitter<void>();
    /** クリアボタン押下イベント */
    @Output() onClickClearEvent = new EventEmitter<UntypedFormGroup>();
    /** 単価表承認権限取得APIレスポンス */
    @Input() sgkc026aResponse: Sgkc026aResponse;
    /** コード変換マスタレスポンス */
    @Input() codeConversionMstMap: Map<string, Array<CodeConversionMstDto>> = null;
    /** 画面モード */
    @Input() mode: string;
    /** 親コンポーネント保持領域 */
    parentForm: UntypedFormGroup;
    /** 検索情報格納FormGroup */
    tankatableConditionInfo: UntypedFormGroup;
    /** 会社 */
    companycode: UntypedFormControl = new UntypedFormControl({ value: '', disabled: true }, Validators.required);
    /** エネルギー種別 */
    energyClscode: UntypedFormControl = new UntypedFormControl({ value: '', disabled: true }, Validators.required);
    /** 承認部門 */
    apprvAuthorityCode: UntypedFormControl = new UntypedFormControl({ value: '', disabled: true }, Validators.required);
    /** 地点群供給地点区分番号 */
    locationgroupSuppntDivisionnumber: UntypedFormControl = new UntypedFormControl({ value: '', disabled: true }, Validators.required);
    /** LP販売形態 */
    lpSalesformcode: UntypedFormControl = new UntypedFormControl({ value: '', disabled: true }, Validators.required);
    /** 適用年月 */
    searchTargetYm: UntypedFormControl = new UntypedFormControl({ value: '', disabled: false });
    /** ステータス */
    apprvStatuscode: UntypedFormControl = new UntypedFormControl({ value: '', disabled: true });
    /** 抽出条件情報リスト */
    extractionConditionInformationList: ExtractionconditionInfoDto[] = [];

    /** コード変換マスタから受け取る会社名のセレクトボックスデータ */
    preCompanyTypeList: PreSelectBox[] = [];
    /** コード変換マスタから受け取るエネルギー種別のセレクトボックスデータ */
    preEnergyTypeList: PreSelectBox[] = [];
    /** コード変換マスタから受け取るLP販売形態のセレクトボックスデータ */
    preLpSalesFormTypeList: PreSelectBox[] = [];
    /** 単価表承認権限取得APIから受け取る承認部門のセレクトボックスデータ */
    preApprovalTypeList: PreSelectBox[] = [];
    /** 単価表承認権限取得APIから受け取る地点群/供給地点区分名称のセレクトボックスデータ(地点群供給地点区分抽出条件情報リスト) */
    preChitenTypeList: LocationgroupsupplypointExtractionconditionInformationDto[] = [];
    /** コード変換マスタから受け取るステータスのセレクトボックスデータ */
    preStatTypeList: PreSelectBox[] = [];

    /** 会社名のセレクトボックスデータ */
    companyTypeList: SelectBox[] = [];
    /** エネルギー種別のセレクトボックスデータ */
    energyTypeList: SelectBox[] = [];
    /** LP販売形態のセレクトボックスデータ */
    lpSalesFormTypeList: SelectBox[] = [];
    /** 承認部門のセレクトボックスデータ */
    approvalTypeList: SelectBox[] = [];
    /** 地点群/供給地点区分名称のセレクトボックスデータ */
    chitenTypeList: SelectBox[] = [];
    /** ステータスのセレクトボックスデータ */
    statTypeList: SelectBox[] = [];

    /**
    * コンストラクタ
    * @param {FormBuilder} fb
    * @param {FormGroupDirective} parent
    * @param {ActivatedRoute} route
    * @memberof Sgkc021dTankaTableSearchConditionComponent
    */
    constructor(
        private fb: UntypedFormBuilder,
        private parent: FormGroupDirective,
        private route: ActivatedRoute,) { }

    /** 
    * 初期処理
    * @memberof Sgkc021dTankaTableSearchConditionComponent
    */
    ngOnInit(): void {
        // 検索情報格納FormGroupを設定する
        this.tankatableConditionInfo = this.fb.group({
            companycode: this.companycode,
            energyClscode: this.energyClscode,
            apprvAuthorityCode: this.apprvAuthorityCode,
            lpSalesformcode: this.lpSalesformcode,
            locationgroupSuppntDivisionnumber: this.locationgroupSuppntDivisionnumber,
            searchTargetYm: this.searchTargetYm,
            apprvStatuscode: this.apprvStatuscode,
        });
        this.parentForm = this.parent.form;
        this.parentForm.addControl('tankatableConditionInfo', this.tankatableConditionInfo);
    }

    /** 
     * コンポーネント破棄時の処理
     * @memberof Sgkc021dTankaTableSearchConditionComponent
     */
    ngOnDestroy(): void {
        if (this.parentForm) {
            this.parentForm.clearValidators();
            this.parentForm.updateValueAndValidity();
            this.parentForm.removeControl('tankatableConditionInfo');
        }
    }

    /**
     * プロパティが変更されたときに、その変更に関する情報を提供する。
     * @param {SimpleChanges} changes
     * @memberof Sgkc021dTankaTableSearchConditionComponent
     */
    ngOnChanges(changes: SimpleChanges) {

        // 対象プロパティが変更された場合のみ処理する
        if (changes.codeConversionMstMap && this.codeConversionMstMap) {
            this.preCompanyTypeList = this.getSelectBoxFromCodeConversionMst("S900020");
            this.preEnergyTypeList.push(...this.getSelectBoxFromCodeConversionMst("S100020"));
            this.preLpSalesFormTypeList.push(...this.getSelectBoxFromCodeConversionMst("S100110"));
            this.preStatTypeList = this.getSelectBoxFromCodeConversionMst("S100031");
        }
        if (changes.sgkc026aResponse && this.sgkc026aResponse) {
            // 抽出条件情報リスト
            this.extractionConditionInformationList = this.sgkc026aResponse.extractionconditionInformationlist;
            // 地点群供給地点区分抽出条件情報リスト
            this.preChitenTypeList = this.sgkc026aResponse.locationgroupsupplypointExtractionconditionInformationlist;
            // 承認部門のセレクトボックスデータ
            this.preApprovalTypeList = this.sgkc026aResponse.apprvAuthorityInformationlist.
                map(data =>
                ({
                    value: String(data.tankaauthorityManagementid),
                    viewValue: data.tankaauthorityManagementname,
                    hyojiRowTurn: String(data.hyojiTurn)
                }));
        }
        if (this.codeConversionMstMap && this.sgkc026aResponse) {

            this.tankatableConditionInfo.reset();
            this.setSelectBox();
        }
    }

    /** 
    * 会社選択後の処理
    * @memberof Sgkc021dTankaTableSearchConditionComponent
    */
    onChangeCompany(): void {
        // 会社コードの以降のフォームを非活性かつ値を初期値にする。
        this.tankatableConditionInfo.controls['energyClscode'].disable();
        this.tankatableConditionInfo.controls['energyClscode'].setValue(this.DEFAULT_SELECT_VALUE);
        this.tankatableConditionInfo.controls['lpSalesformcode'].disable();
        this.tankatableConditionInfo.controls['lpSalesformcode'].setValue(this.DEFAULT_SELECT_VALUE);
        this.tankatableConditionInfo.controls['apprvAuthorityCode'].disable();
        this.tankatableConditionInfo.controls['apprvAuthorityCode'].setValue(this.DEFAULT_SELECT_VALUE);
        this.tankatableConditionInfo.controls['locationgroupSuppntDivisionnumber'].disable();
        this.tankatableConditionInfo.controls['locationgroupSuppntDivisionnumber'].setValue(this.DEFAULT_SELECT_VALUE);
        // エネルギー種別のセレクトボックスデータを設定する
        // 選択した会社情報を取得
        const companyType = this.parentForm.get('tankatableConditionInfo.companycode')?.value
        // 単価表承認権限取得APIで取得したデータを選択した会社名に一致するデータだけ残す。
        const companyfilteredList = this.extractionConditionInformationList.filter(dto => {
            return dto.companycode === companyType; // companycodeが一致するかチェック
        });

        // companyfilteredListをもとに、エネルギー種別のセレクトボックスデータを作成
        const energyTypeArray: string[] = companyfilteredList.map(dto => dto.energyClscode);
        this.energyTypeList = this.makeSelectBoxData(energyTypeArray, this.preEnergyTypeList);
        // リストが複数件存在するときエネルギーのセレクトボックスを活性化
        if (this.energyTypeList.length > 1) {
            this.tankatableConditionInfo.controls['energyClscode'].enable();
        } else if (this.energyTypeList.length === 1) {// リストが1件のときエネルギーのセレクトボックスを活性化、選択を確定
            this.tankatableConditionInfo.controls['energyClscode'].enable();
            this.tankatableConditionInfo.controls['energyClscode'].setValue(this.energyTypeList[0].value);
            this.onChangeEnergy();
        }
    }

    /** 
     * エネルギー種別選択後の処理
     * @memberof Sgkc021dTankaTableSearchConditionComponent
     */
    onChangeEnergy(): void {
        // エネルギー種別の以降のフォームを非活性かつ値を初期値にする。
        this.tankatableConditionInfo.controls['lpSalesformcode'].disable();
        this.tankatableConditionInfo.controls['lpSalesformcode'].setValue(this.DEFAULT_SELECT_VALUE);
        this.tankatableConditionInfo.controls['apprvAuthorityCode'].disable();
        this.tankatableConditionInfo.controls['apprvAuthorityCode'].setValue(this.DEFAULT_SELECT_VALUE);
        this.tankatableConditionInfo.controls['locationgroupSuppntDivisionnumber'].disable();
        this.tankatableConditionInfo.controls['locationgroupSuppntDivisionnumber'].setValue(this.DEFAULT_SELECT_VALUE);
        // 選択した会社情報を取得
        const companyType = this.parentForm.get('tankatableConditionInfo.companycode')?.value
        // 選択したエネルギー種別コードを取得
        const energyType = this.parentForm.get('tankatableConditionInfo.energyClscode')?.value;

        // 単価表承認権限取得APIで取得したデータを選択した会社名とエネルギー種別コードに一致するデータだけ残す。
        const energyFilteredList = this.extractionConditionInformationList.filter(dto => {
            return dto.companycode === companyType && dto.energyClscode === energyType;
        });

        // エネルギー種別がLPガスの場合
        if (energyType === EnergyTypeCode.lpGas) {
            // LP販売形態のセレクトボックスを設定
            // energyFilteredListをもとに、LP販売形態のセレクトボックスデータを作成
            const lpSalesFormTypeArray: string[] = energyFilteredList.map(dto => dto.lpSalesformcode);
            this.lpSalesFormTypeList = this.makeSelectBoxData(lpSalesFormTypeArray, this.preLpSalesFormTypeList)
            // リストが複数件存在するときLP販売形態のセレクトボックスを活性化
            if (this.lpSalesFormTypeList.length > 1) {
                this.tankatableConditionInfo.controls['lpSalesformcode'].enable();
            } else if (this.lpSalesFormTypeList.length === 1) {// リストが1件のときエネルギーのLP販売形態を活性化、選択を確定
                this.tankatableConditionInfo.controls['lpSalesformcode'].enable();
                this.tankatableConditionInfo.controls['lpSalesformcode'].setValue(this.lpSalesFormTypeList[0].value);
                this.onChangeLpSalesForm();
            }
        } else {// エネルギー種別がLPガス以外
            // 承認部門のセレクトボックスを設定
            // energyFilteredList をもとに、承認部門のセレクトボックスデータを作成
            const approvalTypeArray: string[] = energyFilteredList.map(dto => String(dto.apprvTankaauthorityManagementid));
            this.approvalTypeList = this.makeSelectBoxData(approvalTypeArray, this.preApprovalTypeList);
            // リストが複数件存在するとき承認部門のセレクトボックスを活性化
            if (this.approvalTypeList.length > 1) {
                this.tankatableConditionInfo.controls['apprvAuthorityCode'].enable();
            } else if (this.approvalTypeList.length === 1) {// リストが1件のとき承認部門のセレクトボックスを活性化、選択を確定
                this.tankatableConditionInfo.controls['apprvAuthorityCode'].enable();
                this.tankatableConditionInfo.controls['apprvAuthorityCode'].setValue(this.approvalTypeList[0].value);
                this.onChangeApproval();
            }
        }
    }

    /** 
     * LP販売形態選択後の処理
     * @memberof Sgkc021dTankaTableSearchConditionComponent
     */
    onChangeLpSalesForm(): void {
        // LP販売形態の以降のフォームを非活性かつ値を初期値にする。
        this.tankatableConditionInfo.controls['apprvAuthorityCode'].disable();
        this.tankatableConditionInfo.controls['apprvAuthorityCode'].setValue(this.DEFAULT_SELECT_VALUE);
        this.tankatableConditionInfo.controls['locationgroupSuppntDivisionnumber'].disable();
        this.tankatableConditionInfo.controls['locationgroupSuppntDivisionnumber'].setValue(this.DEFAULT_SELECT_VALUE);
        // 承認部門を選択
        // 選択した会社情報を取得
        const companyType = this.parentForm.get('tankatableConditionInfo.companycode')?.value
        // 選択したエネルギー種別コードを取得
        const energyType = this.parentForm.get('tankatableConditionInfo.energyClscode')?.value;
        // 選択したLP販売形態を取得
        const lpSalesFormType = this.parentForm.get('tankatableConditionInfo.lpSalesformcode')?.value;

        // 単価表承認権限取得APIで取得したデータを選択した会社名、エネルギー種別コード、LP販売形態に一致するデータだけ残す。
        const lpSalesformTypeFilteredList = this.extractionConditionInformationList.filter(dto => {
            return dto.companycode === companyType &&
                dto.energyClscode === energyType &&
                dto.lpSalesformcode === lpSalesFormType;
        });
        // lpSalesFormFilteredListをもとに、承認部門のセレクトボックスデータを作成
        const approvalTypeArray: string[] = lpSalesformTypeFilteredList.map(dto => String(dto.apprvTankaauthorityManagementid));
        this.approvalTypeList = this.makeSelectBoxData(approvalTypeArray, this.preApprovalTypeList);
        // リストが複数件存在するとき承認部門のセレクトボックスを活性化
        if (this.approvalTypeList.length > 1) {
            this.tankatableConditionInfo.controls['apprvAuthorityCode'].enable();
        } else if (this.approvalTypeList.length === 1) {// リストが1件のとき承認部門のセレクトボックスを活性化、選択を確定
            this.tankatableConditionInfo.controls['apprvAuthorityCode'].enable();
            this.tankatableConditionInfo.controls['apprvAuthorityCode'].setValue(this.approvalTypeList[0].value);
            this.onChangeApproval();
        }
    }

    /** 
     * 承認部門選択後の処理
     * @memberof Sgkc021dTankaTableSearchConditionComponent
     */
    onChangeApproval(): void {
        // 承認部門以降のフォームを非活性かつ値を初期値にする。
        this.tankatableConditionInfo.controls['locationgroupSuppntDivisionnumber'].disable();
        this.tankatableConditionInfo.controls['locationgroupSuppntDivisionnumber'].setValue(this.DEFAULT_SELECT_VALUE);
        const energyType = this.parentForm.get('tankatableConditionInfo.energyClscode')?.value;
        // エネルギー種別がLPガスの場合
        if (energyType === EnergyTypeCode.lpGas) {
            // 地点群／供給地点区分を設定
            // 選択した承認部門を取得
            const approvalType: string = this.parentForm.get('tankatableConditionInfo.apprvAuthorityCode')?.value;
            // 選択した会社情報を取得
            const companyType = this.parentForm.get('tankatableConditionInfo.companycode')?.value
            // 選択したLP販売形態を取得
            const lpSalesFormType = this.parentForm.get('tankatableConditionInfo.lpSalesformcode')?.value;
            // 単価表承認権限取得APIで取得したデータを会社コードとLP販売形態に一致するデータだけ残す。
            const chitenTypeFilteredList = this.preChitenTypeList.filter(dto => {
                return dto.lpSalesformcode === lpSalesFormType && dto.companycode === companyType;
            });
            // 選択した承認部門をもとに、地点群供給地点区分名称セレクトボックスデータを作成
            this.chitenTypeList = this.makeChitenSelectBoxData(approvalType, chitenTypeFilteredList);
            // リストが1件以上存在するとき地点群供給地点区分名称のセレクトボックスを活性化
            if (this.chitenTypeList.length > 1) {
                this.tankatableConditionInfo.controls['locationgroupSuppntDivisionnumber'].enable();
            } else if (this.chitenTypeList.length === 1) {
                this.tankatableConditionInfo.controls['locationgroupSuppntDivisionnumber'].enable();
                this.tankatableConditionInfo.controls['locationgroupSuppntDivisionnumber'].setValue(this.chitenTypeList[0].value);
            }
        }
    }

    /** 
     * 検索ボタン押下処理
     * @memberof Sgkc021dTankaTableSearchConditionComponent
     */
    onClickSearch(): void {
        this.onClickSearchEvent.emit();
    }

    /** 
     * クリアボタン押下処理
     * @memberof Sgkc021dTankaTableSearchConditionComponent
     */
    onClickClear(): void {
        this.onClickClearEvent.emit();
        this.setSelectBox();
    }

    /** 
     * 必須項目リスト押下処理
     * @memberof Sgkc021dTankaTableSearchConditionComponent
     */
    onSelectOpened(controlsName: string, opened: boolean) {
        // 必須項目の値を取得する。
        const targetValue = this.tankatableConditionInfo.controls[controlsName].value;
        // 値が初期値と同じ かつ リストを閉じた場合はnullに更新する（バリデーションの発生）。
        if (targetValue === this.DEFAULT_SELECT_VALUE && !opened) {
            this.tankatableConditionInfo.controls[controlsName].setValue(null);
        }
    }

    /** 
     * 検索ボタン表示処理
     * @memberof Sgkc021dTankaTableSearchConditionComponent
     */
    isSearchDisabled(): boolean {
        // 必須項目の値を取得する。
        const companycode = this.tankatableConditionInfo.controls['companycode'].value;
        const energyClscode = this.tankatableConditionInfo.controls['energyClscode'].value;
        const lpSalesformcode = this.tankatableConditionInfo.controls['lpSalesformcode'].value;
        const apprvAuthorityCode = this.tankatableConditionInfo.controls['apprvAuthorityCode'].value;
        const locationgroupSuppntDivisionnumber = this.tankatableConditionInfo.controls['locationgroupSuppntDivisionnumber'].value;

        // いずれかの値が初期値だった場合、検索ボタンが非活性となる。
        // エネルギー種別がLPガスの場合
        if (energyClscode === EnergyTypeCode.lpGas) {
            return companycode === this.DEFAULT_SELECT_VALUE
                || energyClscode === this.DEFAULT_SELECT_VALUE
                || lpSalesformcode === this.DEFAULT_SELECT_VALUE
                || apprvAuthorityCode === this.DEFAULT_SELECT_VALUE
                || locationgroupSuppntDivisionnumber === this.DEFAULT_SELECT_VALUE;
        } else {
            return companycode === this.DEFAULT_SELECT_VALUE
                || energyClscode === this.DEFAULT_SELECT_VALUE
                || apprvAuthorityCode === this.DEFAULT_SELECT_VALUE;
        }
    }

    /** 
     * 単価表承認権限取得APIで取得したデータをもとに、セレクトボックスデータを作成する
     * @param {string[]} targetList - 単価表承認権限取得APIで取得したリスト
     * @param {Array<PreSelectBox>} codeList - コード変換マスタから取得したデータ
     * @returns {SelectBox[]} - セレクトボックスデータ
     * @memberof Sgkc021dTankaTableSearchConditionComponent
     */
    makeSelectBoxData(targetList: string[], codeList: Array<PreSelectBox>): SelectBox[] {
        let filteredList: PreSelectBox[];
        let selectBox: SelectBox[]

        // 単価表承認権限取得APIで取得したデータとコード変換マスタから取得したデータを結合
        filteredList = codeList.filter(dto => targetList.includes(dto.value));
        // valueを基準に重複を排除
        filteredList = Array.from(
            new Map(filteredList.map(item => [item.value, item])).values()
        );

        // 項目並び順番で昇順ソート
        filteredList.sort((a, b) => {
            return a.hyojiRowTurn.localeCompare(b.hyojiRowTurn)
        });
        selectBox = filteredList.map(data => ({
            value: data.value,
            viewValue: data.viewValue,
        }))
        return selectBox;
    }

    /** 
     * コード変換マスタから受け取るデータをもとにセレクトボックスデータを作成する
     * @param {string} codeId - コードID
     * @returns {PreSelectBox[]} - セレクトボックスデータ
     * @memberof Sgkc021dTankaTableSearchConditionComponent
     */
    getSelectBoxFromCodeConversionMst(codeId: string): PreSelectBox[] {
        let preSelectBoxList: PreSelectBox[] = [];
        let codeList: CodeConversionMstDto[] = [];
        if (this.codeConversionMstMap.has(codeId)) {
            codeList = this.codeConversionMstMap.get(codeId);
            if (codeList) {
                codeList.forEach(data => {
                    const select: PreSelectBox = { value: data.userCode, viewValue: data.hyojiCont, hyojiRowTurn: data.hyojiRowTurn };
                    preSelectBoxList.push(select);
                })
            }
        }
        return preSelectBoxList;
    }

    /** 
     * 地点群供給地点区分抽出条件情報リストをもとに、地点群供給地点区分名称セレクトボックスデータを作成する
     * @param {string} targetID - 承認単価権限Id
     * @param {Array<LocationgroupsupplypointExtractionconditionInformationDto>} codeList - 地点群供給地点区分抽出条件情報リスト
     * @returns {SelectBox[]} - セレクトボックスデータ
     * @memberof Sgkc021dTankaTableSearchConditionComponent
     */
    makeChitenSelectBoxData(targetID: string, codeList: Array<LocationgroupsupplypointExtractionconditionInformationDto>): SelectBox[] {
        let filteredList: LocationgroupsupplypointExtractionconditionInformationDto[];
        let selectBox: SelectBox[]

        // 承認単価権限Idで地点群供給地点区分抽出条件情報リストをフィルター
        filteredList = codeList.filter(dto => (targetID === String(dto.apprvTankaauthorityManagementid)));
        // 地点群供給地点区分番号を基準に重複を排除
        filteredList = Array.from(
            new Map(filteredList.map(item => [item.locationgroupSuppntDivisionnumber, item])).values()
        );
        selectBox = filteredList.map(data => ({
            value: data.locationgroupSuppntDivisionnumber,
            viewValue: data.locationgroupSuppntDivisionname,
        }))
        return selectBox;
    }

    /** 
     * セレクトボックスの初期設定を行う
     * @memberof Sgkc021dTankaTableSearchConditionComponent
     */
    setSelectBox(): void {
        // 会社コードの値を初期値にする。
        this.tankatableConditionInfo.controls['companycode'].setValue(this.DEFAULT_SELECT_VALUE);

        // 会社コードの以降のフォームを非活性にする。
        this.tankatableConditionInfo.controls['energyClscode'].disable();
        this.tankatableConditionInfo.controls['lpSalesformcode'].disable();
        this.tankatableConditionInfo.controls['apprvAuthorityCode'].disable();
        this.tankatableConditionInfo.controls['locationgroupSuppntDivisionnumber'].disable();

        if (this.mode === DisplayMode.create) {
            // 登録のとき項目を活性、初期表示にブランクを設定
            this.tankatableConditionInfo.controls['apprvStatuscode'].enable();
            this.statTypeList = [{ value: null, viewValue: '' }, // 先頭に空白行を追加
            ...this.preStatTypeList.map(data => ({
                value: data.value,
                viewValue: data.viewValue,
            }))];
        } else if (this.mode === DisplayMode.delete || this.mode === DisplayMode.approve) {
            // 取消または承認のとき初期表示に未承認を設定、項目を非活性、
            // 未承認を先頭に並び替え
            this.tankatableConditionInfo.controls['apprvStatuscode'].disable();
            const targetValue = SearchStat.mishonin;
            const targetItems = this.preStatTypeList.filter(item => item.value === targetValue);
            const otherItems = this.preStatTypeList.filter(item => item.value !== targetValue);
            this.preStatTypeList = [...targetItems, ...otherItems];
            this.statTypeList = [
                ...this.preStatTypeList.map(data => ({
                    value: data.value,
                    viewValue: data.viewValue,
                }))]
        } else if (this.mode === DisplayMode.read) {
            // 参照のとき項目を活性、初期表示に承認済を設定
            // 承認済を先頭に並び替え
            this.tankatableConditionInfo.controls['apprvStatuscode'].enable();
            const targetValue = SearchStat.SHONINZUMI;
            const targetList = this.preStatTypeList.filter(item => item.value === targetValue);
            const otherList = this.preStatTypeList.filter(item => item.value !== targetValue);
            this.preStatTypeList = [...targetList, ...otherList];
            this.statTypeList = [
                ...this.preStatTypeList.map(data => ({
                    value: data.value,
                    viewValue: data.viewValue,
                })),
                { value: null, viewValue: '' } // 最後に空白行を追加
            ];
        }
        this.tankatableConditionInfo.controls['apprvStatuscode'].setValue(this.statTypeList[0].value);

        // extractionConditionInformationListよりcompanycodeを取り出しcompanyTypeArrayに格納
        const companyTypeArray: string[] = this.extractionConditionInformationList.map(dto => dto.companycode);
        // 会社名にセレクトボックスデータを設定
        this.companyTypeList = this.makeSelectBoxData(companyTypeArray, this.preCompanyTypeList);
        // 会社名リストが複数件のと会社名のセレクトボックスを活性化
        if (this.companyTypeList.length > 1) {
            this.tankatableConditionInfo.controls['companycode'].enable();
        } else if (this.companyTypeList.length === 1) {// 会社名リストが1件のときエネルギーのセレクトボックスを活性化、選択を確定
            this.tankatableConditionInfo.controls['companycode'].enable();
            this.tankatableConditionInfo.controls['companycode'].setValue(this.companyTypeList[0].value);
            this.onChangeCompany();
        }
    }
}
